import React, { useState, lazy } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const images = ['https://cdn.magicpatterns.com/uploads/jbqez8LVwuJ5Dpw975rfjw/Screenshot_1.png', 'https://cdn.magicpatterns.com/uploads/e8iXoFyyfDqMzAXgbVUVaL/Screenshot_2.png', 'https://cdn.magicpatterns.com/uploads/tuUVxCRvzUnM5xJafaG2AB/Screenshot_3.png', 'https://cdn.magicpatterns.com/uploads/hbhVu4wFr67zvLMb9p43mp/Screenshot_4.png', 'https://cdn.magicpatterns.com/uploads/9rE4UxBzcqBLB62Kt4rJzm/Screenshot_5.png'];
export function ProductCarousel() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const next = () => setCurrentIndex(prev => (prev + 1) % images.length);
  const prev = () => setCurrentIndex(prev => (prev - 1 + images.length) % images.length);
  return <section className="py-8 px-5 overflow-hidden bg-[#0B0B12]" data-id="element-260">
      <div className="max-w-xl mx-auto text-center" data-id="element-261">
        <h2 className="text-2xl md:text-3xl font-black mb-10 flex items-center justify-center gap-3 text-[#D4B16A] uppercase tracking-tight" data-id="element-262">
          📸 MIRÁ EL MATERIAL POR DENTRO
        </h2>

        <div className="flex items-center justify-between mb-8 text-slate-400 px-2" data-id="element-263">
          <button onClick={prev} className="p-3 hover:text-brand-primary transition-colors bg-white rounded-xl shadow-sm border border-slate-100" aria-label="Anterior" data-id="element-264">
            <ChevronLeft size={24} data-id="element-265" />
          </button>

          <span className="uppercase tracking-[0.2em] text-slate-300 text-[12px] font-[600]" data-id="element-266">
            Desliza para ver más
          </span>

          <div className="flex items-center gap-6" data-id="element-267">
            <button onClick={next} className="p-3 hover:text-brand-primary transition-colors bg-white rounded-xl shadow-sm border border-slate-100" aria-label="Siguiente" data-id="element-268">
              <ChevronRight size={24} data-id="element-269" />
            </button>
          </div>
        </div>

        <div className="relative aspect-[3/4] md:aspect-[4/5] overflow-hidden mb-10 rounded-3xl bg-white shadow-2xl border border-white/10 flex items-center justify-center max-w-md mx-auto" data-id="element-270">
          <AnimatePresence mode="wait" data-id="element-271">
            <motion.div key={currentIndex} initial={{
            opacity: 0,
            scale: 0.95
          }} animate={{
            opacity: 1,
            scale: 1
          }} exit={{
            opacity: 0,
            scale: 1.05
          }} transition={{
            duration: 0.3,
            ease: 'easeInOut'
          }} className="w-full h-full" data-id="element-272">
              <img src={images[currentIndex]} alt={`Vista previa del material ${currentIndex + 1}`} className="w-full h-full object-cover" loading="lazy" data-id="element-273" />
            </motion.div>
          </AnimatePresence>
        </div>

        <div className="flex justify-center gap-3" data-id="element-274">
          {images.map((_, idx) => <button key={idx} onClick={() => setCurrentIndex(idx)} className={`h-2 rounded-full transition-all duration-300 ${idx === currentIndex ? 'w-10 bg-brand-primary' : 'w-2 bg-slate-200'}`} aria-label={`Ir a imagen ${idx + 1}`} data-id="element-275" />)}
        </div>
      </div>
    </section>;
}